import React , { useState } from 'react'
import { AccordionItem,
   
    Collapse,
    UncontrolledTooltip,
  
    ListGroup,
    ListGroupItem,
 
 } from 'reactstrap';
import classnames from "classnames";
import { useDispatch } from 'react-redux';
import { open_favourite_modal, set_fav_prompt_modal_edit_mode_values, set_Fav_Prompt_Question } from '../../slices/Favourite_Prompt/reducer';
import Sql_Preview_modal from '../../Components/Common/CustomModal/Sql_Preview_modal';
import Add_User_To_Group_Modal from '../../Components/Common/CustomModal/Add_User_To_Group_Modal';
import { useSelector } from 'react-redux';
import { botDetails } from '../../helpers/url_helper';
import Parameters_Modal from '../../Components/Common/CustomModal/Parameters_Modal'; 
import { v4 as uuidv4 } from "uuid"; // For generating unique IDs for components
const Favourite_Prompt_Accordian = ({ Favourite_Prompt_Category, Favorite_Prompt , delete_fav_prompt , query }) => {
  const { User_Role , Database_ID } = useSelector((state) => state.BotDetails.Bot_Details);
  const [unique_id, setunique_id] = useState(uuidv4())
    
    const [col1, setcol1] = useState(false);
    const t_col1 = () => {
        setcol1(!col1);
    
      };
const dispatch = useDispatch()


  return (
    <AccordionItem >
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className={classnames("accordion-button", {
                          collapsed: !col1,
                        })}
                        type="button"
                        onClick={t_col1}
                        style={{ cursor: "pointer" }}
                      >
                        {Favourite_Prompt_Category}
                      </button>
                    </h2>

                    <Collapse
                      isOpen={col1}
                      className="accordion-collapse"
                      id="collapseOne"
                    >
                      <div className="accordion-body fav_p_list_body" style={{padding:'5px'}}>
                        <ListGroup>
                          {Favorite_Prompt.map((fav_prompt, index) => {
                            const { Description , Prompt_Question , Bot_Favorite_Prompt_ID ,  Bot_ID,
                              assistant_id,
                              thread_id,
                              Prompt_Category,
                              Prompt_Refresh_Frequency,
                              Notification_Email,
                              Notification_Mobile,
                              Prompt_Result_Time,
                              Prompt_Result,
                              Allow_User_Run_Prompt,
                              Allow_User_Run_SQL,
                              Allow_User_See_Prompt_SQL,
                              Allow_Only_Download,
                              query,
                              question,
                              description,
                              PromptFrequencyType,
                              WeeklyDays,
                              Prompt_SQL
                               } = fav_prompt;
                            return (
                              
                              <ListGroupItem
                                key={index}
                                className="d-flex justify-content-between align-items-center"
                                style={{padding:'5px'}}
                              >
                                <div className="chek_name fav_chek_name" data-id={Description.replaceAll(/[^a-z0-9]/gi, '').trim()}>
                                  <span className="text-muted">
                                    {Description}                                    
                                    
                                  </span>
                                </div>
                                <UncontrolledTooltip 
  placement="bottom" 
  target={`[data-id='${Description.replaceAll(/[^a-z0-9]/gi, '').trim()}']`} 
>
  {Description}
</UncontrolledTooltip>
                                <div className="dedt">
                                  { 
                                  Prompt_SQL.length> 0 && 
                                    <span>                                 
                                      {(( (User_Role =='BotUser' || User_Role =='Viewer') && Allow_User_Run_SQL)  ||(User_Role =='BotAdmin'))  && <Sql_Preview_modal  Description={Description} database_id={Database_ID} sql_query={Prompt_SQL} />}
                                      {/* {(( (User_Role =='BotUser' || User_Role =='Viewer') && Allow_User_Run_SQL)  ||(User_Role =='BotAdmin'))  && <Parameters_Modal />} */}
                                    </span>
                                  }
                                   { ( ((User_Role =='BotUser' || User_Role =='Viewer') && Allow_User_Run_Prompt)  ||(User_Role =='BotAdmin')  ) && <span onClick={()=>{
                                      dispatch(set_Fav_Prompt_Question(Prompt_Question))
                                    }} >
                                      <b>Run</b>
                                    </span>}
                                   {( User_Role !=='Viewer' &&  User_Role !=='BotUser' ) && <span onClick={()=>{
                              
                                      
                                      dispatch(set_fav_prompt_modal_edit_mode_values(fav_prompt))
                                      dispatch(open_favourite_modal(true))
                                    }} >
                                      <i className="ri-pencil-line"></i>
                                    </span>}
                                    { (User_Role !=='BotUser' && User_Role !=='Viewer' ) && <span onClick={()=>{
                                      delete_fav_prompt(Bot_Favorite_Prompt_ID)
                                    }} >
                                      <i className="ri-delete-bin-line"></i>
                                    </span>}
                                </div>
                              </ListGroupItem>
                            );
                          })}
                        </ListGroup>
                  
                      </div>
                    </Collapse>
                  </AccordionItem>
                  
  )
}

export default Favourite_Prompt_Accordian